module.exports = __webpack_public_path__ + "media/components/assets/radio_unselected-9aac7de191263b3cc56bc15acce637a0.svg";